import { z } from "zod";

const POSITIVE_INT_MESSAGE = "Must be a positive integer";

const optionalPositiveIntegerSchema = z.preprocess((value) => {
	if (value === "" || value === null || value === undefined) {
		return null;
	}
	// Matches positive integers greater than 0.
	// First digit must be 1-9 (no leading zero),
	// followed by zero or more digits.
	if (typeof value === "string" && /^[1-9]\d*$/.test(value)) {
		return Number(value);
	}

	return value;
}, z
	.number({ invalid_type_error: POSITIVE_INT_MESSAGE })
	.int(POSITIVE_INT_MESSAGE)
	.min(1, POSITIVE_INT_MESSAGE)
	.nullish());

export const getGeneralSetupFormSchema = () => {
	return z.object({
		adamServiceFeePercentage: z.number().int().nullish(),
		adamServiceFeeVATPercentage: z.number().int().nullish(),
		customerVATPercentage: z.number().int().nullish(),
		depositLimitAmount: z.number().int().nullish(),
		staticDepositAmount: z.number().int().nullish(),
		depositPercentage: z.number().int().nullish(),
		expresFeePrice: z.number().int().nullish(),
		emailReplyTo: z.string().email().nullish(),
		dailyThreshold: z.number().int().nullish(),
		allocationMaxDrivingDistanceKm: optionalPositiveIntegerSchema,
	});
};

export type GeneralSetupFormSchema = z.infer<
	ReturnType<typeof getGeneralSetupFormSchema>
>;
